export default __webpack_public_path__ + "static/media/warning--triple-lanes-left-turn-or-go-straight--g1.f5c35777.png";